import {React, useState, useEffect}from 'react';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText'
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import DetailsItems from './DetailsItems';
import Alert from '@mui/material/Alert';
import orderHelpers from '../../../helpers/orders';
import fileHelpers from '../../../helpers/files';

function DetailsPallet(props) {

    const shipment = props.shipment || {items: []};


    useEffect(() => {
    },)


    return (
            <Box display = "flex" flexDirection = "column" style = {{height: "500px", marginTop:"20px"}}>
                <Typography variant = "h4" align = "center">On Shipment</Typography>
                <Divider flexItem />
                <Box display = "flex" flexDirection = "column" style = {{overflowY:"scroll", height:"60%"}}>
                    <DetailsItems items = {shipment.line} />
                </Box>
            </Box>
    )
}

export default DetailsPallet;